function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAustraliaFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5700 3000",
    style: {
      enableBackground: "new 0 0 5700 3000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00008B"
    },
    points: "0,0 0,1000.114 0,2000.057 0,3000 5700,3000 5700,2000.057 5700,1000.114 5700,0  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1464.416,1810.746 1548.939,2061.383 1796.808,1970.834 1654.471,2193.623  1879.051,2330.749 1616.851,2358.434 1648.958,2619.169 1464.416,2431.883 1279.899,2619.169 1311.982,2358.434  1049.782,2330.749 1274.199,2193.623 1131.862,1970.834 1379.731,2061.383  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "3562.989,1138.963 3602.4,1255.406 3717.54,1213.389 3651.42,1316.966 3755.649,1380.643  3633.856,1393.509 3648.814,1514.674 3562.989,1427.709 3477.326,1514.674 3492.17,1393.509 3370.329,1380.643 3474.72,1316.966  3408.6,1213.389 3523.74,1255.406  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "4274.674,365.717 4314.086,482.16 4429.226,440.143 4363.105,543.557 4467.497,607.234  4345.542,620.263 4360.5,741.429 4274.674,654.3 4189.011,741.429 4203.856,620.263 4082.014,607.234 4186.406,543.557  4120.286,440.143 4235.426,482.16  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "4907.7,947.606 4946.949,1064.049 5062.251,1022.031 4995.969,1125.446 5100.36,1189.286  4978.543,1202.151 4993.363,1323.317 4907.7,1236.189 4821.875,1323.317 4836.857,1202.151 4715.04,1189.286 4819.269,1125.446  4753.148,1022.031 4868.313,1064.049  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "4275,2267.4 4314.412,2383.843 4429.551,2341.663 4363.456,2445.24 4467.684,2508.917  4345.843,2521.783 4360.826,2642.948 4275,2555.983 4189.337,2642.948 4204.157,2521.783 4082.34,2508.917 4186.731,2445.24  4120.611,2341.663 4235.751,2383.843  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "4560.651,1516.466 4592.083,1592.031 4673.511,1598.383 4611.463,1652.289  4630.354,1730.949 4560.651,1689.42 4490.949,1730.949 4509.84,1652.289 4447.792,1598.383 4529.22,1592.031  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2929,0 2600.952,0 1708.528,458.445 1708.528,0 1220.305,0 1220.305,458.445 327.881,0  0,0 0,167.673 644.045,498.563 0,498.563 0,998.669 644.045,998.669 0,1329.558 0,1497.231 327.881,1497.231 1220.305,1038.787  1220.305,1497.231 1708.528,1497.231 1708.528,1038.787 2600.952,1497.231 2929,1497.231 2929,1329.558 2284.787,998.669  2929,998.669 2929,498.563 2284.787,498.563 2929,167.673  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF0000"
    },
    points: "1612.456,0 1316.376,0 1316.376,596.972 0,596.972 0,900.259 1316.376,900.259  1316.376,1497.231 1612.456,1497.231 1612.456,900.259 2929,900.259 2929,596.972 1612.456,596.972  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF0000"
    },
    points: "2929,0 2710.748,0 1734.495,498.563 1956.237,498.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF0000"
    },
    points: "0,1497.231 218.11,1497.231 1194.363,998.669 972.763,998.669  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF0000"
    },
    points: "976.11,498.563 0,0 0,113.497 753.171,498.563  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF0000"
    },
    points: "1952.722,998.669 2929,1497.231 2929,1383.735 2175.661,998.669  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAustraliaFlag);
export default __webpack_public_path__ + "static/media/australia_flag.b295944347439b258d171411c1d43f1d.svg";
export { ForwardRef as ReactComponent };